require("core-js/modules/esnext.global-this.js");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-twitch-embed-video"] = t(require("react")) : e["react-twitch-embed-video"] = t(e.react);
}(self, function (e) {
  return function () {
    "use strict";

    var t = {
      927: function _(e, t, r) {
        var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
          void 0 === n && (n = r), Object.defineProperty(e, n, {
            enumerable: !0,
            get: function get() {
              return t[r];
            }
          });
        } : function (e, t, r, n) {
          void 0 === n && (n = r), e[n] = t[r];
        }),
            o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
          Object.defineProperty(e, "default", {
            enumerable: !0,
            value: t
          });
        } : function (e, t) {
          e.default = t;
        }),
            u = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var r in e) {
            "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
          }
          return o(t, e), t;
        },
            i = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var a = u(r(297)),
            l = i(r(586)),
            c = r(409),
            d = r(540),
            f = r(236),
            s = r(832),
            v = r(273),
            p = r(502),
            _ = function _() {
          var e, t;
          return Boolean(null === (t = null === (e = l.default) || void 0 === e ? void 0 : e.Twitch) || void 0 === t ? void 0 : t.Embed);
        },
            y = function y(e) {
          var t = e.width,
              r = e.height,
              n = e.targetId,
              o = e.targetClass,
              u = a.useRef(null),
              i = d.useTwitchEmbed(e),
              p = i[0],
              y = i[1],
              b = f.useEventListener(p),
              h = v.usePlayerReady(p, e),
              E = s.usePlayerPlay(p, e);
          return a.useEffect(function () {
            if (_()) {
              var e = l.default.Twitch.Embed,
                  t = e.VIDEO_PLAY,
                  r = e.VIDEO_READY,
                  n = b(t, E),
                  o = b(r, h);
              return function () {
                o(), n();
              };
            }
          }, [h, b, E]), a.useEffect(function () {
            u && u.current && (u.current.innerHTML = ""), _() ? y() : c.loadEmbedApi(y);
          }, [y]), a.default.createElement("div", {
            ref: u,
            style: {
              width: t,
              height: r
            },
            className: o,
            id: n
          });
        };

        y.defaultProps = {
          targetId: p.DEFAULT_TARGET_ID,
          width: p.DEFAULT_HEIGHT,
          height: p.DEFAULT_WIDTH,
          autoplay: !0,
          muted: !1
        }, t.default = a.default.memo(y);
      },
      409: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.loadEmbedApi = t.EMBED_URL = void 0, t.EMBED_URL = "https://embed.twitch.tv/embed/v1.js";

        var r = function r() {};

        t.loadEmbedApi = function (e) {
          void 0 === e && (e = r);
          var n = document.createElement("script");
          n.setAttribute("src", t.EMBED_URL), n.addEventListener("load", e), document.body.append(n);
        };
      },
      540: function _(e, t, r) {
        var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) {
              for (var o in t = arguments[r]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        },
            o = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useTwitchEmbed = void 0;
        var u = r(297),
            i = o(r(586)),
            a = r(502);

        t.useTwitchEmbed = function (e) {
          var t = u.useState(),
              r = t[0],
              o = t[1],
              l = u.useCallback(function () {
            var t,
                r = new i.default.Twitch.Embed(null !== (t = e.targetId) && void 0 !== t ? t : "", n({}, e));
            o(r);
          }, [e]);
          return a.tuplify(r, l);
        };
      },
      236: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useEventListener = void 0;

        var n = r(297),
            o = function o() {};

        t.useEventListener = function (e) {
          return n.useCallback(function (t, r) {
            return e ? (e.addEventListener(t, r), function () {
              return e.removeEventListener(t, r);
            }) : o;
          }, [e]);
        };
      },
      832: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.usePlayerPlay = void 0;
        var n = r(297);

        t.usePlayerPlay = function (e, t) {
          var r = t.autoplay,
              o = t.onPlay,
              u = n.useState(r),
              i = u[0],
              a = u[1];
          return n.useCallback(function () {
            return e ? i ? o && o() : (e.getPlayer().pause(), void a(!0)) : null;
          }, [o, e, a, i]);
        };
      },
      273: function _(e, t, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.usePlayerReady = void 0;
        var n = r(297);

        t.usePlayerReady = function (e, t) {
          var r = t.autoplay,
              o = t.muted,
              u = t.onReady;
          return n.useCallback(function () {
            if (e) {
              var t = e.getPlayer();
              !function (e, t) {
                e.setVolume(t ? 0 : 1);
              }(t, o), function (e, t) {
                !t && e.pause();
              }(t, r), u && u(t);
            } else console.warn("Player not provided");
          }, [e, o, r, u]);
        };
      },
      984: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DEFAULT_HEIGHT = t.DEFAULT_WIDTH = t.DEFAULT_TARGET_ID = void 0, t.DEFAULT_TARGET_ID = "twitch-embed", t.DEFAULT_WIDTH = "940", t.DEFAULT_HEIGHT = "480";
      },
      502: function _(e, t, r) {
        var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
          void 0 === n && (n = r), Object.defineProperty(e, n, {
            enumerable: !0,
            get: function get() {
              return t[r];
            }
          });
        } : function (e, t, r, n) {
          void 0 === n && (n = r), e[n] = t[r];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var r in e) {
            "default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(r(984), t), o(r(529), t);
      },
      529: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.tuplify = void 0, t.tuplify = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          return e;
        };
      },
      586: function _(e, t, r) {
        e.exports = "object" == typeof self && self.self === self && self || "object" == typeof r.g && r.g.global === r.g && r.g || this;
      },
      297: function _(t) {
        t.exports = e;
      }
    },
        r = {};

    function n(e) {
      var o = r[e];
      if (void 0 !== o) return o.exports;
      var u = r[e] = {
        exports: {}
      };
      return t[e].call(u.exports, u, u.exports, n), u.exports;
    }

    return n.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), n(927);
  }();
});